import { render } from "./EditPersonalInfos.vue?vue&type=template&id=df436116&scoped=true"
import script from "./EditPersonalInfos.vue?vue&type=script&lang=js"
export * from "./EditPersonalInfos.vue?vue&type=script&lang=js"

import "./EditPersonalInfos.vue?vue&type=style&index=0&id=df436116&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-df436116"

export default script